import $ from 'jquery'
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import VueSanitize from "vue-sanitize";

Vue.use(VueHtml2pdf)


let defaultOptions = {
    allowedTags: ['img', 'png', 'jpeg', 'jpg'],
    allowedAttributes: {
      'img': [ 'src', 'alt' ]
    }
};
Vue.use(VueSanitize, defaultOptions);

export default {
    name: 'info-clinique',
    components: {
        VueHtml2pdf
    },
    props: [],
    data() {
        return {
            info_clinique: {
                'logo': '', 'type_centre': 'Clinique', 'nom': '',
                'pays': '', 'ville': '', 'adresse': '', 'specialites': '',
                'code_autorisation': '', 'entete': '',
            },
            is_loading: false,
            save_loading: false,
            default_country: '',
            default_city: '',

            img_url: ''
        }
    },
    computed: {
        config_info_clinique() {
            return this.$store.getters["config_info_clinique"];
        },
    },

    mounted() {
        this.getInfoClinique()
        
    },
    methods: {
        previewFile(el) {
            var file = document.querySelector('input[name='+el+']').files[0];
            var reader = new FileReader();
            
            if (file) {
                reader.readAsDataURL(file);
                if (el == 'logo') {
                    this.info_clinique.logo = file
                    $('.hd-prev-1').fadeOut(500)
                } else if (el == 'entete') {
                    this.info_clinique.entete = file
                    $('.hd-prev-2').fadeOut(500)
                }
            }

            reader.addEventListener("load", function () {
                $('#preview-'+el).css('background-image', 'url('+reader.result+')');
            }, false);
        },

        initFields() {
            console.log("CITY: ",this.default_city)
            const fld_keys = Object.keys(this.info_clinique);
            fld_keys.forEach((key) => {

                if (key == 'logo' || key == 'entete') {
                    if (this.config_info_clinique[key] != '') {
                        // let file_url = this.assets_path+'/config/'+this.config_info_clinique[key]

                        // $('#preview-'+key).css('background-image', 'url('+file_url+')');
                        setTimeout(() => {
                            this.fillMedia()
                        }, 2000);
                    }
                } 

                if (key == 'ville') {
                    this.info_clinique[key] = (this.config_info_clinique[key] == null || this.config_info_clinique[key] == '')?this.default_city:this.config_info_clinique[key]
                } else if (key == 'pays') {
                    this.info_clinique[key] = (this.config_info_clinique[key] == null || this.config_info_clinique[key] == '')?this.default_country:this.config_info_clinique[key]
                } else {
                    this.info_clinique[key] = this.config_info_clinique[key]
                }
                this.is_loading = false
                
            });
        },

        fillMedia() {
            const fld_keys = Object.keys(this.info_clinique);
            fld_keys.forEach((key) => {
                if (key == 'logo' || key == 'entete') {
                    if (this.config_info_clinique[key] != '' &&  this.config_info_clinique[key] != undefined) {

                        if (key == 'logo') {
                            // this.info_clinique.logo = file_url
                            $('.hd-prev-1').fadeOut(500)
                        } else if (key == 'entete') {
                            // this.info_clinique.entete = file_url
                            $('.hd-prev-2').fadeOut(500)
                        }

                        let file_url = this.assets_path+'/config/'+this.config_info_clinique[key]
                        $('#preview-'+key).css('background-image', 'url('+file_url+')');
                    }
                }

                this.is_loading = false
                
            });
        },

        setLocal() {
            var city = ''
            var country = ''
            $.ajax({
                url: 'https://ip-api.com/json',
                type: 'GET',
                success: function(json) {
                    country = json.country
                    city = json.city
                    
                }, error: function() {
                    // 
                }
            }).then(() => {
                this.default_city = city
                this.default_country = country
                console.log("CITYEE after: ",this.default_city)
            })
            
        },

        async getInfoClinique() {
            this.is_loading = true
            this.setLocal()
            this.$store.dispatch('getConfigInfoClinique', 'info_clinique').then(() => {
                this.initFields()
            })
        },

        saveConfig() {
            this.save_loading = true

            let form_data = new FormData();
            for (let key in this.info_clinique) {
                form_data.append(key, (this.info_clinique[key] == null)?'':this.info_clinique[key])
            }
            form_data.append('data_type', 'info_clinique')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.getInfoClinique()
                }

                this.save_loading = false
            })
        },

        previewEntete() {
            this.img_url = this.$sanitize(this.assets_path+'/config/'+this.config_info_clinique['entete'])
            // this.img_url = new Image()
            // this.img_url.crossOrigin = "Anonymous"
            // // this.img_url.addEventListener("load", this.imageReceived, false)
            // this.img_url.src = dimg
            this.$refs.html2Pdf.generatePdf()
        },

        imageReceived() {
            let canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");
          
            canvas.width = this.img_url.width;
            canvas.height = this.img_url.height;
          
            context.drawImage(this.img_url, 0, 0);
            // imageBox.appendChild(canvas);
          
            try {
              localStorage.setItem("saved-image-example", canvas.toDataURL("image/png"));
            }
            catch(err) {
              console.log("Error: " + err);
            }
        }
    }
}


